import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import CommonPageHeader from '../../components/CommonPageHeader/CommonPageHeader';
import MedicalFormArea from './MedicalFormArea/MedicalFormArea';
import { getFAQSchema } from './MedicalFormArea/faqData';
import { trackEvent } from '../../Analytics';

const MedicalFormLanding = () => {
  // Get the FAQ schema from the shared data source
  const faqSchema = getFAQSchema();

  useEffect(() => {
    // Capture UTM parameters and track CBC campaign landing
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const utmCampaign = urlParams.get('utm_campaign');
    const utmMedium = urlParams.get('utm_medium');
    const utmContent = urlParams.get('utm_content');
    const utmTerm = urlParams.get('utm_term');

    // Check if this is a CBC campaign landing
    if (utmSource === 'cbc') {
      console.log('🔥 CBC Campaign Landing Detected');

      // Store CBC attribution with 30-day expiration
      const cbcAttribution = {
        source: utmSource,
        campaign: utmCampaign || 'default',
        medium: utmMedium || 'display',
        content: utmContent,
        term: utmTerm,
        landing_time: new Date().toISOString(),
        landing_page: '/medicalform',
        expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString() // 30 days
      };

      localStorage.setItem('cbc_campaign_attribution', JSON.stringify(cbcAttribution));
      sessionStorage.setItem('campaign_source', 'cbc'); // Simple flag for payment tracking

      // Track CBC landing event in GA4
      trackEvent('cbc_landing', {
        campaign_source: 'cbc',
        campaign_name: utmCampaign || 'default',
        campaign_medium: utmMedium || 'display',
        campaign_content: utmContent || '',
        page_location: window.location.href,
        page_title: document.title
      });

      console.log('✅ CBC attribution stored and tracked');
    }

    // Track general page view for all visitors
    trackEvent('medicalform_landing', {
      utm_source: utmSource || 'direct',
      utm_campaign: utmCampaign || '',
      utm_medium: utmMedium || '',
      page_location: window.location.href
    });
  }, []); // Run once on component mount

  return (
    <>
      <Helmet>
        <title>South Vancouver Medical Clinic | Form Completion Service</title>
        <link rel="canonical" href="https://southvanmed.com/medicalform" />
        <meta name="description" content="Complete your medical forms starting at $250. We provide quick processing for disability, insurance, and return-to-work forms within 1-2 business days." />
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <CommonPageHeader
        title="Need a Form Filled Out? We Can Help."
        subtitle="Medical Form Service"
        pageDescription="At the South Van Medical Clinic, we offer a convenient service to help with your paperwork needs. No appointment necessary."
      />

      <MedicalFormArea />
    </>
  );
};

export default MedicalFormLanding;
